
(function(){
function initBdb(root){
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var C = JSON.parse(root.querySelector('[data-bdb-config]').textContent);
  var T = C.t;
  var $ = function(s){ return root.querySelector(s); };
  var $$ = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var tpl = function(s, o){ return String(s||'').replace(/\[([^\]]+)\]/g, function(m,k){ return (o && k in o) ? o[k] : m; }); };

  // Pengeformat afledt af Shopifys eget format for markedets valuta
  var MF = (function(){
    var s = C.moneySample, mm = s.match(/1(\D?)(23[45])(?:(\D)(56))?/);
    if (!mm) return function(c){ return (c/100).toFixed(2) + ' ' + C.currency; };
    var pre = s.slice(0, mm.index), suf = s.slice(mm.index + mm[0].length);
    var th = mm[1] || '', dec = mm[3] || ',', hasDec = !!mm[4];
    // Nordisk visning: DKK 1.234,56 kr, SEK og NOK 1 234,56 kr
    if (C.currency === 'DKK') { th = '.'; dec = ','; }
    else if (C.currency === 'SEK' || C.currency === 'NOK') { th = ' '; dec = ','; }
    return function(cents){
      var neg = cents < 0; cents = Math.abs(Math.round(cents));
      var whole = hasDec ? Math.floor(cents / 100) : Math.round(cents / 100), frac = cents % 100;
      var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, th);
      if (hasDec && frac !== 0) out += dec + (frac < 10 ? '0' : '') + frac;
      return (neg ? '-' : '') + pre + out + suf;
    };
  })();

  var P = C.products, S = C.sizes;
  var byId = {}; P.forEach(function(p){ byId[p.id] = p; });
  var state = { size: 0, order: [], qty: {}, mode: 'sub', gift: false, busy: false, boxId: null };
  P.forEach(function(p){ state.qty[p.id] = 0; });
  var size = function(){ return S[state.size] || {n:3,d:0,option:0,plan:0,freq:''}; };
  // Abonnementsrabat for valgt størrelse (matcher selling planens rabat i Subi)
  var sdNow = function(){ var s = size(); return (s.sd !== undefined && s.sd !== null) ? +s.sd : +C.subDisc; };
  // Den procent kunden ser i teksterne. Kan sættes lavere end Subi-rabatten, så pakkerabat + abonnement lægges sammen til den samlede rabat
  var slNow = function(){ var s = size(); return (s.sl !== undefined && s.sl !== null && s.sl !== '') ? +s.sl : sdNow(); };
  var pct = function(n){ return Math.round(n) + '%'; };
  var fsGoal = (C.fsLocal ? C.fsAmount : C.fsAmount * Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1)) * 100;

  function toast(msg){ var t=$('[data-toast]'); t.textContent=msg; t.classList.add('show'); clearTimeout(toast._t); toast._t=setTimeout(function(){ t.classList.remove('show'); }, 2400); }

  function totals(){
    var sub = state.order.reduce(function(s,id){ return s + byId[id].price; }, 0);
    var d1 = Math.round(sub * size().d / 100);
    var d2 = state.mode==='sub' ? Math.round((sub - d1) * sdNow() / 100) : 0;
    var g = (state.gift && C.gift) ? C.gift.price : 0;
    return { sub: sub, d1: d1, d2: d2, gift: g, total: sub - d1 - d2 + g };
  }

  function add(id){
    if (state.order.length >= size().n) return;
    state.qty[id]++; state.order.push(id); render();
    if (state.order.length === size().n) toast(tpl(T.toastFull, { procent: pct(size().d) }));
  }
  function remove(id){ var i = state.order.lastIndexOf(id); if (i<0) return; state.order.splice(i,1); state.qty[id]--; render(); }
  function removeAt(i){ var id = state.order[i]; state.order.splice(i,1); state.qty[id]--; render(); }
  function setSize(i){
    state.size = i; var cut = 0;
    while (state.order.length > size().n){ var id = state.order.pop(); state.qty[id]--; cut++; }
    render(); if (cut) toast(tpl(T.toastCut, { antal: cut }));
  }

  function render(){
    // Gaveposen tilbydes kun ved engangskøb (blandet fragtprofil ved abonnement)
    if (state.mode === 'sub') state.gift = false;
    var sz = size(), c = state.order.length, full = c >= sz.n, t = totals(), rem = sz.n - c, isSub = state.mode === 'sub', sd = sdNow(), sl = slNow();
    $$('[data-card]').forEach(function(card){
      var id = card.getAttribute('data-card'), q = state.qty[id] || 0;
      card.classList.toggle('on', q > 0);
      card.querySelector('[data-qty]').textContent = q;
      card.querySelector('[data-badge]').textContent = tpl(T.qtyBadge, { antal: q });
      card.querySelector('[data-inc]').disabled = full;
      card.querySelector('[data-dec]').disabled = q === 0;
    });
    $$('[data-size]').forEach(function(b){ b.setAttribute('aria-pressed', +b.getAttribute('data-size') === state.size ? 'true' : 'false'); });
    var slots = $('[data-slots]'); slots.innerHTML = '';
    slots.className = 'bdb-slots s' + sz.n;
    for (var i = 0; i < sz.n; i++){
      var id = state.order[i];
      if (id){
        var p = byId[id], b = document.createElement('button');
        b.type = 'button'; b.className = 'bdb-slot full'; b.setAttribute('aria-label', T.removeSlot + ' ' + p.name);
        b.innerHTML = (p.img ? '<img src="'+p.img+'" alt="" loading="lazy">' : '<span>'+p.name+'</span>') + '<span class="x" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></span>';
        (function(ix){ b.addEventListener('click', function(){ removeAt(ix); }); })(i);
        slots.appendChild(b);
      } else {
        var d = document.createElement('div'); d.className = 'bdb-slot'; d.textContent = T.empty; slots.appendChild(d);
      }
    }
    $('[data-count]').textContent = tpl(T.count, { antal: c, total: sz.n });
    $('[data-bar]').style.width = Math.round(c / sz.n * 100) + '%';
    $$('[data-mode]').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-mode') === state.mode ? 'true' : 'false'); });
    var tag = $('[data-sub-tag]');
    if (tag && T.subTag){ tag.textContent = tpl(T.subTag, { procent: pct(sl) }); tag.hidden = !(sd > 0); }
    $('[data-sub-small]').textContent = tpl(C.subFreeShip ? T.subTextFs : T.subText, { frekvens: sz.freq });
    $('[data-sub]').textContent = MF(t.sub);
    $('[data-disc-lbl]').textContent = tpl(T.discLbl, { procent: pct(sz.d) });
    $('[data-disc]').textContent = (t.d1 > 0 ? '-' : '') + MF(t.d1);
    $('[data-subdisc-row]').hidden = !(isSub && sd > 0);
    $('[data-subdisc-lbl]').textContent = tpl(T.subDiscLbl, { procent: pct(sl) });
    $('[data-subdisc]').textContent = '-' + MF(t.d2);
    $('[data-gift-row]').hidden = !state.gift;
    $('[data-gift-lbl]').textContent = isSub ? T.giftLblSub : T.giftLbl;
    var gb = $('[data-gift]');
    if (gb){ gb.hidden = isSub; gb.setAttribute('aria-pressed', state.gift ? 'true' : 'false'); $('[data-gift-sub]').textContent = T.giftText; }
    $('[data-total]').textContent = MF(t.total);
    $('[data-per]').textContent = isSub ? tpl(T.perSub, { frekvens: sz.freq }) : T.perOnce;
    var free = t.total >= fsGoal || (isSub && C.subFreeShip);
    var subFs = isSub && C.subFreeShip;
    $('[data-fs]').hidden = c === 0 && !subFs;
    $('[data-fs-on]').hidden = !free; $('[data-fs-off]').hidden = free;
    $('[data-fs-on-txt]').textContent = subFs ? T.fsSub : T.fsDone;
    $('[data-fs-txt]').innerHTML = tpl(T.fsLeft, { 'beløb': '<b>' + MF(fsGoal - t.total) + '</b>', belob: '<b>' + MF(fsGoal - t.total) + '</b>' });
    $('[data-fs-bar]').style.width = Math.min(100, Math.round(t.total / fsGoal * 100)) + '%';
    var label = state.busy ? T.ctaAdding : (full ? (state.boxId ? T.ctaUpdate : (isSub ? T.ctaSub : T.ctaOnce)) : tpl(T.ctaMore, { antal: rem }));
    $$('[data-cta]').forEach(function(b){ b.disabled = !full || state.busy; b.textContent = label; });
    var hint = full ? '' : (c === 0 ? T.hintStart : tpl(T.hintMore, { antal: rem, procent: pct(sz.d) }));
    $('[data-hint]').textContent = hint; $('[data-hint]').hidden = !hint;
    $('[data-m-total]').textContent = MF(t.total);
    var saved = t.d1 + t.d2, ms = $('[data-m-save]');
    ms.className = saved > 0 ? 'save' : '';
    ms.textContent = c === 0 ? T.mNone : (saved > 0 ? tpl(T.mSave, { 'beløb': MF(saved), belob: MF(saved) }) : tpl(T.count, { antal: c, total: sz.n }));
    updDlg();
  }

  // Produktdialog
  var dlg = $('[data-dlg]'), dlgId = null;
  function openDlg(id){
    var p = byId[id]; if (!p) return; dlgId = id;
    $('[data-dlg-hero]').innerHTML = p.imgLarge ? '<img src="'+p.imgLarge+'" alt="">' : '';
    $('[data-dlg-name]').textContent = p.name; $('[data-dlg-ml]').textContent = p.ml || ''; $('[data-dlg-ml]').hidden = !p.ml;
    $('[data-dlg-type]').textContent = p.type || '';
    var chk = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    var ul = $('[data-dlg-list]'); ul.innerHTML = '';
    (p.bullets || []).forEach(function(b){ b = (b||'').trim(); if (!b) return; var li = document.createElement('li'); li.innerHTML = '<i style="background:'+(p.accent||'#305d61')+'">'+chk+'</i><span></span>'; li.lastChild.textContent = b; ul.appendChild(li); });
    $('[data-dlg-price]').textContent = MF(p.price);
    updDlg(); dlg.showModal();
  }
  function updDlg(){
    if (!dlgId) return; var q = state.qty[dlgId], full = state.order.length >= size().n;
    $('[data-dlg-in]').textContent = q > 0 ? tpl(T.inPack, { antal: q }) : T.perPiece;
    var b = $('[data-dlg-add]'); b.disabled = full; b.textContent = full ? T.full : (q > 0 ? T.addMore : T.add);
  }
  $('[data-dlg-add]').addEventListener('click', function(){ if (dlgId){ add(dlgId); dlg.close(); } });
  $('[data-dlg-close]').addEventListener('click', function(){ dlg.close(); });
  dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });

  // Hændelser
  $('[data-grid]').addEventListener('click', function(e){
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-inc')) add(b.getAttribute('data-inc'));
    if (b.hasAttribute('data-dec')) remove(b.getAttribute('data-dec'));
    if (b.hasAttribute('data-info')) openDlg(b.getAttribute('data-info'));
  });
  $$('[data-size]').forEach(function(b){ b.addEventListener('click', function(){ setSize(+b.getAttribute('data-size')); }); });
  $$('[data-mode]').forEach(function(b){ b.addEventListener('click', function(){ state.mode = b.getAttribute('data-mode'); render(); }); });
  var gb = $('[data-gift]'); if (gb) gb.addEventListener('click', function(){ state.gift = !state.gift; render(); });

  // Læg i kurv. Samme format som Subis egen widget.
  function boxId(){ var s = ''; while (s.length < 11) s += Math.floor(Math.random()*16).toString(16); return s; }
  var root_url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  function post(path, body){
    return fetch(root_url + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); });
  }
  function mine(item, bid){ var p = item.properties || {}; return p._build_box_id === bid || p._bdb_gift === bid; }
  // Fjern en tidligere udgave af samme pakke, så en ændring erstatter den i stedet for at lægge en ekstra pakke i kurven
  function clearOld(bid){
    if (!bid) return Promise.resolve();
    return fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
      var upd = {}, n = 0;
      (cart.items || []).forEach(function(it){ if (mine(it, bid)) { upd[it.key] = 0; n++; } });
      return n ? post('cart/update.js', { updates: upd }) : null;
    });
  }
  function addToCart(){
    var sz = size(); if (state.order.length !== sz.n || state.busy) return;
    state.busy = true; $('[data-err]').hidden = true; render();
    var bid = state.boxId || boxId(), items = [];
    Object.keys(state.qty).forEach(function(id){
      var q = state.qty[id]; if (!q) return;
      var it = { id: +id, quantity: q, properties: { _build_box_id: bid, _build_box_option_id: sz.option } };
      if (state.mode === 'sub' && sz.plan) it.selling_plan = sz.plan;
      items.push(it);
    });
    if (state.gift && C.gift) items.push({ id: C.gift.id, quantity: 1, properties: { _bdb_gift: bid } });
    clearOld(state.boxId)
      .then(function(){ return post('cart/add.js', { items: items }); })
      .then(function(){
        state.busy = false; state.boxId = bid; render();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch(function(err){ console.error('Byg din boks:', err); state.busy = false; render(); $('[data-err]').hidden = false; });
  }
  // Fjerner kunden pakken i kurven, nulstilles siden til udgangspunktet
  document.addEventListener('cart:updated', function(e){
    var cart = e && e.detail && e.detail.cart; if (!cart || !state.boxId || state.busy) return;
    var still = (cart.items || []).some(function(it){ return mine(it, state.boxId); });
    if (!still){
      state.boxId = null; state.order = []; state.gift = false; state.size = 0; state.mode = 'sub';
      P.forEach(function(p){ state.qty[p.id] = 0; });
      render();
    }
  });
  $$('[data-cta]').forEach(function(b){ b.addEventListener('click', addToCart); });

  $$('[data-money]').forEach(function(el){ el.textContent = MF(+el.getAttribute('data-money')); });
  var tr = $('[data-trust1]'); if (tr) tr.textContent = tpl(tr.textContent, { 'beløb': MF(fsGoal), belob: MF(fsGoal) });
  render();

  // Rediger pakken: ?box=<id> fra kurven henter pakken ind igen
  var mBox = location.search.match(/[?&]box=([0-9a-f]+)/);
  if (mBox) {
    var rbid = mBox[1];
    fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
      var lines = (cart.items || []).filter(function(it){ return it.properties && it.properties._build_box_id === rbid; });
      if (!lines.length) return;
      var opt = +lines[0].properties._build_box_option_id, si = -1;
      S.forEach(function(s, i){ if (s.option === opt) si = i; });
      if (si < 0) return;
      state.size = si; state.order = []; P.forEach(function(p){ state.qty[p.id] = 0; });
      lines.forEach(function(it){
        var id = String(it.variant_id); if (!byId[id]) return;
        for (var k = 0; k < it.quantity && state.order.length < S[si].n; k++){ state.qty[id]++; state.order.push(id); }
      });
      state.mode = lines.some(function(it){ return !!it.selling_plan_allocation; }) ? 'sub' : 'once';
      state.gift = (cart.items || []).some(function(it){ return it.properties && it.properties._bdb_gift === rbid; });
      state.boxId = rbid; render();
    }).catch(function(){});
  }
}
function boot(){ Array.prototype.forEach.call(document.querySelectorAll('.bdb'), initBdb); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
